import { z } from 'zod';

export const ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE = 'AdminUserPasswordResetToken';

export const AdminUserPasswordResetTokenPayloadSchema = z.object({
    type: z.literal(ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE),
    adminUserId: z.string(),
    /**
     * NB: this field is consumed by the client only, only has a presentational purposes
     */
    email: z.string(),
});

export type AdminUserPasswordResetTokenPayload = Readonly<z.infer<typeof AdminUserPasswordResetTokenPayloadSchema>>;
